export default __webpack_public_path__ + "static/media/utivacolored.7364336b.svg";